import React from "react";
import MusicPlayer from "./MusicPlayer";
import './App.css'

function App() {
  return (
    <div className="App">
      <MusicPlayer />
    </div>
  );
}

export default App;
